import { render } from "./Quizz.vue?vue&type=template&id=69763c08&scoped=true"
import script from "./Quizz.vue?vue&type=script&lang=js"
export * from "./Quizz.vue?vue&type=script&lang=js"

import "./Quizz.vue?vue&type=style&index=0&id=69763c08&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69763c08"]])

export default __exports__